import Account from "@/helper/AccountHelper.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import CampaignModel from '../model/CampaignModel.js';
import { map } from 'rxjs/operators';
import ConfigManager from '@/config/ConfigManager.js';

/**
 * @method apiGetCampaign
 * @method apiGetCampaignDetail
 * @method apiSaveCampaignRating
 * @method apiAddFavourite
 * @method apiRemoveFavourite
 */
export default {
    /**
     * @param {Object} objListConfig (Require) CampaignListConfigModel - /core/Campaign/model/CampaignConfigModel.js
     * @param {Object} objListFilterConfig (Optional) CampaignListFilterConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    //TODO: Revise
    apiGetCampaign: function (token ,objListConfig, objListFilterConfig) {
        var params = objListConfig.getParams();
        if (objListFilterConfig != null) {
            var filter = objListFilterConfig.getParams();
            params = {...params , ...filter};
        }

        const url = ConfigManager.getApiUrl() + "/campaign";
        // const url = 'http://localhost:3000' + "/campaign";
        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                var arrCampaign = [];
                for (var i of res.data) {
                    var objCampaign = new CampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                return arrCampaign;
            }));
    },

    /**
     * @param {Object} objDetailConfig (Require) CampaignConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaignDetail: function (objDetailConfig, targetToken, targetJwt) {
        const token = targetToken != null ? targetToken : Account.getToken();
        const jwt = targetJwt != null ? targetJwt : Account.getJwt();
        var params = objDetailConfig.getParams();
        const url = ConfigManager.getApiUrl() + `/campaign/${objDetailConfig.strId}`;
        // const url = 'http://localhost:3000' + `/campaign/${objDetailConfig.strId}`;
        return BzbsApi.connectBzbsGet(url, token, params, jwt)
            .pipe(map((res) => {
                var campaign = new CampaignModel(res.data);
                return campaign;
            }));
    },

    /**
     * @param {string|number} campaignId
     * @param {number} rating
     * @param {string} message (optional)
     */
    apiSaveCampaignRating: function (campaignId, rating, message) {
        const token = Account.getToken();
        const params = {
            rating: rating,
        };

        if (message) {
            params.message = message;
        }
        var url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/buzz`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {string} campaignId
     */
    apiAddFavourite: function(campaignId) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/favourite`;
        return BzbsApi.connectBzbsPost(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {string} campaignId
     */
    apiRemoveFavourite: function(campaignId) {
        const token = Account.getToken();
        let url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/favourite`;
        return BzbsApi.connectBzbsDelete(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

    apiGetFavouriteList: function (cateId) {
        const token = Account.getToken();
        let params = {};
        if (cateId != null) {
            params.cat = cateId;
        }

        let url = ConfigManager.getApiUrl() + "/api/profile/me/favourite_campaign";
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            let campaignList = [];
            for (let i of res.data) {
                let campaign = new CampaignModel(i);
                campaignList.push(campaign);
            }

            return campaignList;
        }));
    },
}
